/**
 * Core
 */
import { React } from 'react'
import { useLocation, Link } from 'react-router-dom'
/**
 * Components
 */
import Footer from '../components/footer'


const JudgeProfile = () => {

    const location = useLocation();
    console.log(location,"get data");
            
    return (
        <>
        <section className='bg-gray-200 text-ai-gray-900 pt-16'>
            <div>                   
                <div className='bg-white/30 p-8 relative mt-16'>
                    <img className='absolute -top-16 left-0 w-32 h-32 ml-8 rounded-full object-cover' src={`https://awintern.com${location.state.profile_image ? location.state.profile_image : '/assets/img/user-solid.svg'}`} alt={location.state.name} />
                    <p className='font-semibold pt-12'>{location.state.name}</p>
                    <p className='pt-0'>{location.state.job_title}</p>
                    <p className='pt-0'>{location.state.organization}</p>
                    <p className='pt-8 text-lg'>{location.state.bio}</p>
                </div>

                <div className='reveal top active m-auto'>
                    <button>
                        <Link to={'/meet-the-judges'}>
                            <div>Back to Judges page</div>
                        </Link>
                    </button>  
                </div>
            </div>
        </section>

        <section className='pb-0 border-t border-t-ai-gray-800'>
            <Footer />
        </section>


        {/* <img className='w-48 h-48 object-cover rounded-[50%] m-auto' src={`https://awintern.com${location.state.profile_image ? location.state.profile_image : '/assets/img/user-solid.svg'}`} alt={location.state.name} />
        <p className='text-2xl font-semibold'>location.state.name</p>
        <p className='text-xl font-medium pt-2'>{location.state.job_title}</p>
        <p className='text-lg pt-2'>{location.state.organization}</p>
        <p className='text-lg text-left pt-10'>{location.state.bio}</p> */}
        </>
    )
}

export default JudgeProfile